<template>
  <TsColumn v-if="showSpendMoreAlert" class="is-12 mb-2">
    <TsCard
      data-testid="trolley-spend-x-more-for-free-shipping-alert"
      append-class="bg-natural-grey"
      noShadow
      noBorder
    >
      <TsTypography
        append-class="mb-0 text-idle-white"
        as="p"
        data-testid="trolley-spend-x-more-for-free-shipping-amount"
        variant="sm"
      >
        {{ useTranslation("spendJust", "Besteed nog") }}
        <span class="font-semibold"
          >€{{
            (
              trolleyStore.free_ship_buffer -
              (trolleyStore.trolley.order_response?.subtotals?.inc_vat.raw ?? 0)
            ).toFixed(2).replace(".", ",")
          }}</span
        >
        {{ useTranslation("deliveryMessage", "voor GRATIS bezorging.") }}
      </TsTypography>
      <NuxtLinkWithLocale
        to="/"
        data-testid="trolley-continue-shopping-cta-under-order-summary"
        class="text-sm mb-0 underline hover:no-underline text-idle-white cursor-pointer"
        >{{ useTranslation("continueShopping", "Ga door met winkelen") }}
      </NuxtLinkWithLocale>
    </TsCard>
  </TsColumn>
</template>

<script lang="ts" setup>
import { useTranslation } from "~/composables/useTranslation";

const TsCard = defineAsyncComponent(
  () => import("~/components/organisms/TsCard.vue")
);

const trolleyStore = useTrolleyStore();

const showSpendMoreAlert = computed(() => {
  if (trolleyStore.trolley.is_all_lines_collection) return false;
  return (
    trolleyStore.free_ship_buffer >
    (trolleyStore.trolley.order_response?.subtotals?.inc_vat.raw ?? Infinity)
  );
});
</script>
